import Head from './../components/Head';
import Footer from './../components/Footer';
import Course from './components/Course';
import VirtualList from './components/virtualList';
import ResourceCenter from './components/ResourceCenter.vue';
import SpocCourse from './components/SpocCourse.vue';
import TeacherList from './components/TeacherList';
import BannerList from './components/BannerList';
import News from './components/News';
import TeacherData from './components/TeachData.vue';
import Link from '../components/aboutLink.vue';
import TeachingCenterList from './components/TeachingCenterList.vue';
import Lecture from './components/Lecture/index.vue';
export default {
  components: {
    Head,
    Course,
    TeacherList,
    BannerList,
    News,
    Footer,
    SpocCourse,
    TeacherData,
    Link,
    ResourceCenter,
    TeachingCenterList,
    Lecture,
    VirtualList
  },

  provide() {
    return {
      uuid: () => this.uuid,
      userId: () => this.userId
    };
  },

  created() {
    this.getDataList();
  },

  watch: {
    menuInfo(newVal) {
      this.menuInfo = newVal;
      this.roleType = this.menuInfo.roleType;
      this.getPession();
    },

    isLogin(val) {
      this.isLogin = val; //true 登录  false 没登录

      this.getPession();
    }

  },

  data() {
    return {
      isLogin: null,
      showNone: false,
      roleType: [],
      menuCode: '10301',
      dataList: [],
      liveList: [],
      footerItem: null,
      dataItem: null,
      bannerItem: null,
      moocItem: [],
      spocItem: null,
      newsItem: null,
      teacherItem: null,
      teachingCenterItem: null,
      menuInfo: {},
      userInfo: null,
      zhsRole: 0,
      uuid: '',
      userId: '',
      lectureItem: null,
      virtualItem: null
    };
  },

  methods: {
    async getDataList() {
      const res = await this.$http.getDataList();
      console.log('首页数据', res);
      this.dataList = res;
      this.footerItem = this.dataList.find(item => item.function_id == '10303');
      this.dataItem = this.dataList.find(item => item.function_id == '10304');
      this.bannerItem = res.find(item => item.function_id == '10302');
      this.moocItem = res.filter(item => item.function_id == '10401');
      this.spocItem = res.find(item => item.function_id == '10402');
      this.newsItem = res.find(item => item.function_id == '10701');
      this.teacherItem = res.find(item => item.function_id == '10501');
      this.teachingCenterItem = res.find(item => item.function_id == '51001');
      this.lectureItem = this.dataList.filter(item => item.function_id == '40005');
      this.virtualItem = this.dataList.find(item => item.function_id == '13200');
      this.$nextTick(() => {
        if (this.footerItem) {
          this.setColor(this.footerItem, '.home-footer');
        }
      });
    },

    setColor(data, className) {
      //背景图
      if (data.backImage) {
        let dom = document.querySelector(className);

        if (dom) {
          dom.style.background = `url(${data.backImage}) no-repeat center bottom`;
          dom.style.backgroundSize = 'cover';
        }

        return;
      } //背景色


      if (data.backColor) {
        let dom = document.querySelector(className);
        if (dom) dom.style.background = data.backColor;
      }
    },

    getUserInfo(data) {
      this.userInfo = data;
      this.uuid = data.uuid;
      this.userId = data.id;
    },

    getZhsRole(data) {
      this.zhsRole = data || 0;
    }

  }
};